export const wpHowToClass = 'schema-how-to';
export const wpHowToTotalTimeClass = 'schema-how-to-total-time';
export const wpHowToDescriptionClass = 'schema-how-to-description';
export const wpHowToStepsClass = 'schema-how-to-steps';